import React, { useState, useEffect, useMemo, useCallback, memo } from 'react';
import { Link } from 'react-router-dom';
import { joinWaitlist } from '../../api/auth';

import styles from './styles/Auth.module.css';

// WAITLIST_PHASE
const Waitlist = () => {
    const [email, setEmail] = useState('');
    const [sourceInfo, setSourceInfo] = useState('');
    const [referralCode, setReferralCode] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [isWaitlistSent, setIsWaitlistSent] = useState(false);
    const [error, setError] = useState('');

    const isFormValid = useMemo(() => {
        return email;
    }, [email]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const ref = urlParams.get('ref');
        if (ref) {
            const referralCode = ref.toUpperCase().replace(/\s+/g, '');
            localStorage.setItem('referralCode', referralCode);
            setReferralCode(referralCode);
        } else {
            const localReferralCode = localStorage.getItem('referralCode');
            if (localReferralCode) {
                setReferralCode(localReferralCode);
            }
        }

        // Remove params from URL
        window.history.replaceState({}, '', window.location.pathname);
    }, []);

    const handleSubmit = useCallback(async e => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await joinWaitlist(email, referralCode, sourceInfo);
            setIsWaitlistSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    }, [email, referralCode, sourceInfo]);

    if (isWaitlistSent) {
        return (
            <div className={styles.container}>
                <Link to="/">
                    <img 
                        src="/icons/android-icon-192x192.png"
                        alt="JetChats Logo"
                        className={styles.logo}
                    />
                </Link>
                <div className={styles.card}>
                    <h2>Thank you for joining the waitlist!</h2>
                    <p className={styles.text}>We'll notify you when we give you access to the app.</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <Link to="/">
                <img 
                    src="/icons/android-icon-192x192.png" 
                    alt="JetChats Logo" 
                    className={styles.logo}
                />
            </Link>
            <div className={styles.card}>
                <h2>Join the Waitlist</h2>
                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.formGroup}>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={e => setEmail(e.target.value.toLowerCase())}
                            required
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label htmlFor="source">How did you hear about us?</label>
                        <input
                            type="text"
                            id="source"
                            name="source"
                            value={sourceInfo}
                            onChange={e => setSourceInfo(e.target.value)}
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label htmlFor="referralCode">Referral Code (optional)</label>
                        <input
                            type="text"
                            id="referralCode"
                            name="referralCode"
                            value={referralCode}
                            onChange={e => {
                                const value = e.target.value.toUpperCase().replace(/\s+/g, '');
                                setReferralCode(value);
                                localStorage.setItem('referralCode', value);
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        className={styles.submitButton}
                        disabled={isLoading || !isFormValid}
                    >
                        {isLoading ? 'Joining...' : 'Join Waitlist'}
                    </button>
                </form>
                {error && <p className={styles.error}>{error}</p>}
            </div>
        </div>
    );
};

export default memo(Waitlist);
